import { Component, OnInit, ViewChild, OnDestroy, ElementRef } from '@angular/core';

import { v4 as uuid } from "uuid";
import { DxDataGridComponent } from "devextreme-angular";
import { Router } from "@angular/router";
import { Subscription } from 'rxjs';
import { Menu } from 'src/app/models/menu';
import { MicroapplicationService } from 'src/app/services/microapplications/_services/microapplication.service';
import { MenuGroupItem } from 'src/app/models/menu.model';
import { MessagesService } from 'src/app/services/service.index';
import { Page } from 'src/app/models/page.model';
@Component({
  selector: "app-application-list",
  templateUrl: "./application-list.component.html",
  styleUrls: ["./application-list.component.scss"],
})
export class ApplicationListComponent implements OnInit, OnDestroy {
  formId = uuid();
  gridId = uuid();
  configToolBar = { add: true };
  listActions: Menu[];
  refreshButtonOptions: any;
  addButtonOptions: any;
  private unsubscribe: Subscription[] = [];

  @ViewChild(DxDataGridComponent, { static: false }) dataGrid;
  @ViewChild('jsonImportButton') jsonImportButton: ElementRef;
  pagesSe: Page[] = [];
  pagesSse: Page[] = [];
  jsonBase64 = '';
  txtImportar = 'Importar';
  constructor(
    public microApps: MicroapplicationService,
    private router: Router,
    private messagesService: MessagesService
  ) {

    // this.refreshButtonOptions = {
    //   icon: "refresh",
    //   onClick: () => { this.microApps.GetAllMicroApplications();

    // }}

    this.addButtonOptions = {
      icon: "plus",
      hint: 'Nueva',
      onClick: () => {
        this.addMicroApp();
      },
    };
  }

  ngOnInit(): void {
    const sub = this.microApps.GetAllMicroApplications();
    this.unsubscribe.push(sub);
    this.pagesSe = [];
    const df = this.pagesSse;

    sessionStorage.setItem('Pages', JSON.stringify(this.pagesSe));
    sessionStorage.removeItem('Pages');
  }


  onRowDblClick(e: any) {
    this.editMicroApp(e.data.id);
  }
  gridHeight = () => {
    return Math.round(window.innerHeight / 1.3);
  };


  editMicroAppclick = (e: any) => {
    this.editMicroApp(e.row.data.id);
  };

  editMicroApp(id: any) {
    this.router.navigate(["microapplication-settings"], {
      queryParams: {
        pId: id,
      },
    });
  }

  itemClickToolbar(item: MenuGroupItem) {
    if (!item) {
      return;
    }
    switch (item.name) {
      case "new":
        this.addMicroApp();
        break;
    }
  }
  addMicroApp() {
    this.router.navigate(["microapplication/microapplication-settings"], {});
  }

  import() {
    this.jsonImportButton.nativeElement.click();
  }

  changeFileJSONButton(e: any) {
    if (e.target.files && e.target.files.length > 0) {
      let file = e.target.files[0];
      if (!file.name.endsWith('.json')) {
        this.messagesService.error(`Solo se permiten archivos .json`);
        return;
      }
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = (r) => {
        this.jsonBase64 = (r as any).target.result;
        this.jsonBase64 = this.jsonBase64.replace('data:application/json;base64,', '');
        this.importJson();
      };
      reader.onerror = function (error) {
        //console.log('Error: ', error);
      };
      e.target.value = '';
    }
  }

  importJson() {
    //this.microApps.loadingSubject.next(true);
    this.txtImportar = 'Espere...';
    this.microApps.importJSONFile(decodeURIComponent(escape(atob(this.jsonBase64)))).subscribe(result => {
      if (result.IsSucessfull) {
        this.microApps.loadingSubject.next(false); 
        this.txtImportar = 'Importar';
      }
      else
        this.txtImportar = 'Importar';
    }, err => {
      this.microApps.loadingSubject.next(false);
      this.txtImportar = 'Importar';
    });    
  }

  ngOnDestroy(): void {
    //Called once, before the instance is destroyed.
    //Add 'implements OnDestroy' to the class.
    this.unsubscribe.forEach(sub => {
      sub.unsubscribe();
    });

  }

}
